<template>
    <div class="form-group">
        <span
            data-test-id="total-licenses"
            class="license-count"
        >
            <template v-if="purchases.length > 0">Total: {{ usedCount }}/{{ totalLicenses }} Licenses</template>
            <template v-else>No Licenses Purchased</template>
        </span>
        <table
            v-if="purchases.length > 0"
            class="licenses-table"
        >
            <thead>
                <tr>
                    <th>Purchase Date</th>
                    <th>License Count</th>
                </tr>
            </thead>
            <tr
                v-for="(purchase, i) in licensePurchases"
                :key="i"
                class="license"
                :data-test-id="`license-purchase-${i}`"
            >
                <td>
                    <input
                        v-model="purchase.purchased_on"
                        :data-test-id="`purchase-date-${i}`"
                        type="date"
                        required
                        @change="licensesChanged"
                    />
                </td>
                <td>
                    <input
                        v-model="purchase.count"
                        :data-test-id="`purchase-count-${i}`"
                        type="number"
                        min="1"
                        required
                        @change="licensesChanged"
                    />
                </td>
                <td>
                    <span
                        class="icon-delete"
                        data-test-id="delete-purchase-button"
                        @click.prevent="deletePurchase(i)"
                    />
                </td>
            </tr>
        </table>
        <div class="add-purchase">
            <button
                data-test-id="add-license"
                @click.prevent="addLicense()"
            >
                +
            </button>
            Add New License Assignment
        </div>
    </div>
</template>

<script>
import { closeModal, openModal } from 'jenesius-vue-modal'
import canConfirm from '@/mixins/canConfirm'
import ConfirmModal from './Modal/ConfirmModal.vue'

export default {
    mixins: [canConfirm],

    props: {
        purchases: {
            type: Array,
            default: () => [],
        },
        usedCount: {
            type: Number,
            required: true,
        },
        licenseOverageIsVisible: {
            type: Boolean,
            required: true,
        },
    },

    data() {
        return {
            licensePurchases: this.purchases,
        }
    },

    computed: {
        totalLicenses() {
            return this.purchases.reduce((accumulator, purchase) => accumulator + purchase.count, 0)
        },
    },

    watch: {
        purchases(newValue) {
            this.licensePurchases = newValue
        },
    },

    methods: {
        addLicense() {
            this.licensePurchases.push({
                count: null,
                purchased_on: null,
            })
            this.licensesChanged()
        },
        licensesChanged() {
            this.$emit('license-purchase-change', this.licensePurchases)
        },
        deletePurchase(index) {
            if (this.licenseOverageIsVisible && this.licensePurchases.length === 1) {
                this.confirm({
                    header: 'Overage Requires Licenses',
                    message: 'Before removing all licenses, you must disable overages',
                    acceptLabel: 'OK',
                    rejectLabel: null,
                })
            } else {
                const purchase = this.licensePurchases[index]
                openModal(ConfirmModal, {
                    label: 'Confirm',
                    text: `Are you sure you want to delete these ${purchase.count} license purchases?`,
                    confirm: () => {
                        this.licensePurchases.splice(index, 1)
                        this.licensesChanged()
                        closeModal()
                    },
                    cancel: () => {
                        closeModal()
                    },
                })
            }
        },
    },
}
</script>

<style scoped lang="scss">
.license-count {
    color: #a5a4a4;
    font-size: 15px;
    font-weight: 900;
}

.licenses-table {
    font-family: Avenir, serif;
    font-size: 16px;
    font-style: normal;
    font-weight: 350;
    line-height: normal;
    padding: 6px 0;
    margin-top: 10px;

    th {
        text-align: left;
    }

    td {
        padding: 3px 3px 0 0;

        input {
            display: inline;
            width: 75px;
        }

        input[type='date'] {
            width: 150px;
            margin-right: 10px;
        }

        .icon-delete {
            cursor: pointer;
        }
    }
}

.add-purchase {
    margin-top: 15px;

    input {
        width: 185px;
        display: block;
        margin-top: 10px;
    }
}
</style>
